if (!AoPS.hasOwnProperty("Community")) {
	AoPS.Community = {};
}

AoPS.Community.is_active =
	AoPS.bootstrap_data.hasOwnProperty("is_community_active") &&
	AoPS.bootstrap_data.is_community_active;

AoPS.Community.Utils = {
	ajax_runner: new AoPS.Ajax.ScriptRunner("/m/community/ajax.php", {
		max_retries: 1,
	}),

	onclick_latex_activated: false,

	activateLatexOnclick: function () {
		if (AoPS.Community.Utils.onclick_latex_activated) {
			return;
		}
		$(document).on("click", "img.latex, img.latexcenter", function (e) {
			// Disable this in Self Paced 2 Transporter scripts.
			if (AoPS.bootstrap_data.is_sp2) {
				if ($(this).parents(".aops-transporter-main").length) {
					return;
				}
			}

			if (e.metaKey || e.ctrlKey) {
				// Open new window with code someone else will write
			} else {
				if (
					$(this).attr("alt") &&
					$(this).closest(".aops-modal-body").length === 0
				) {
					AoPS.Community.Utils.throwLaTeXOnModal({
						event: e,
						latex_image: this,
					});
				}
			}
		});

		$(document).on("click", "img.asy-image", function (e) {
			// Disable this in Self Paced 2 Transporter scripts.
			if (AoPS.bootstrap_data.is_sp2) {
				if ($(this).parents(".aops-transporter-main").length) {
					return;
				}
			}

			// Disable this in motor homework problems
			if ($(this).parents(".motor-homework-body").length) {
				return;
			}

			if (e.metaKey || e.ctrlKey) {
				// Open new window with code someone else will write
			} else {
				if (
					$(this).attr("alt") &&
					$(this).closest(".aops-modal-body").length === 0
				) {
					AoPS.Community.Utils.throwAsyOnModal({
						event: e,
						asy_image: this,
					});
				}
			}
		});

		AoPS.Community.Utils.onclick_latex_activated = true;
	},

	throwLaTeXOnModal: function (obj) {
		var cloned_image = obj.latex_image.cloneNode(false),
			code = $.trim(_.escape(obj.latex_image.alt)).replace(
				/(?:\r\n|\r|\n)/g,
				"<br />"
			),
			$output;

		$output = $('<div class="latex-modal"></div>').append(cloned_image);
		$output.append(
			'<div class="latex-modal-bottom">\
							<div class="latex-modal-bottom-title"><u>LaTeX code below</u></div>\
							<div class="latex-modal-code">' +
				code +
				"</div>\
						</div>"
		);
		if ($output.showModal) {
			$output.showModal({
				frame_class: "latex-modal-wrapper",
				max_width: "500px",
				scrollable: true,
			});
		}
	},

	/**
	 * Take a website input that is www.xxxxx  or http://www.xxxx  and return
	 *  something we can stick in an href
	 *  SL: also account for HTTPS
	 **/
	formatUrl: function (url) {
		if (url.substr(0, 7) === "http://" || url.substr(0, 8) === "https://") {
			return url;
		} else {
			return "http://" + url;
		}
	},

	idler_started: false,

	is_cmty_asleep: false,

	putCommunityToSleep: function (obj) {
		AoPS.Community.Utils.cmty_ajax.ajax_active = false;
		AoPS.Community.Utils.is_cmty_asleep = true;
		if (obj && obj.error_type === "E_INVALID_SESSION_WRONG") {
			AoPS.Community.Lang["community-asleep"] =
				AoPS.Community.Lang["community-asleep-session"];
			AoPS.Community.Lang["community-asleep-save"] =
				AoPS.Community.Lang["community-asleep-save-session"];
			AoPS.Community.Lang["community-asleep-reminder"] =
				AoPS.Community.Lang["community-asleep-reminder-session"];
		}

		AoPS.Ui.Modal.showMessage(AoPS.Community.Lang["community-asleep"], {
			width: "450px",
		});
		if (!_.isUndefined(AoPS.Community.Utils.idle_monitor_interval)) {
			clearInterval(AoPS.Community.Utils.idle_monitor_interval);
			// Just in case we ever want to try restarting...
			this.idler_started = false;
		}

		if (typeof AoPS.Community.MasterModel === "object") {
			AoPS.Community.MasterModel.set("cmty_status", "disabled");
		}
	},

	/**
	 * Watch if a user touches anything. If they don't, put the community
	 * to sleep and stop all ajax activity.
	 *
	 * More documentation at https://github.com/aops/aops3/wiki/Community-Throttle
	 **/
	startIdleMonitor: function () {
		var last_activity = Date.now();

		if (this.idler_started) {
			return;
		}

		function checkIfIdle() {
			var now = Date.now();
			var limit =
				AoPS.Community.Constants.intervals.current.put_community_to_sleep_limit;

			if (now - last_activity >= limit) {
				AoPS.Community.Utils.putCommunityToSleep();
			}
		}

		$(document).on("mousemove touchmove click keypress", function (e) {
			last_activity = Date.now();
		});

		AoPS.Community.Utils.idle_monitor_interval = setInterval(
			checkIfIdle,
			AoPS.Community.Constants.idle_monitor_interval
		);
	},

	throwAsyOnModal: function (obj) {
		var cloned_image = obj.asy_image.cloneNode(false),
			code = $.trim(_.escape(obj.asy_image.alt)).replace(
				/(?:\r\n|\r|\n)/g,
				"<br />"
			),
			$output;

		$output = $('<div class="latex-modal"></div>').append(cloned_image);

		$output.append(
			'<div class="latex-modal-bottom">\
							<div class="latex-modal-bottom-title"><u>Asymptote code below</u></div>\
							<div class="latex-modal-code">' +
				code +
				"</div>\
						</div>"
		);
		$output.showModal({
			frame_class: "latex-modal-wrapper",
			max_width: "500px",
			scrollable: true,
		});
	},

	extractValueFromUrl: function (stub, url_in) {
		var match_array;
		if (_.isNull(url_in)) {
			return 0;
		}
		match_array = url_in.match(new RegExp(stub + "(\\d+)"));
		if (_.isNull(match_array)) {
			return 0;
		} else {
			return parseInt(match_array[1]);
		}
	},

	hexToRgb: function (hex_string) {
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex_string);
		return result
			? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16),
				}
			: null;
	},

	/****
	 * All Ajax call objects have the following structure
	 *
	 *	a string : action to send to the back end
	 *	params object : settings to send to the back end
	 *	main_handler function : main handler to execute upon return
	 *  call_cancel_on_timeout boolean : (optional, default false) Change any E_AJAX_TIMEOUT to E_AJAX_CANCEL, so same handler is used.
	 *	never_cancel boolean (optional, default false) : true to prevent ever canceling
	 *	extra_handlers object (optional) : extra handlers for the call
	 *		onFinish : what to do if the ajax call finishes successfully
	 *		onError : what to do if there is an error in the Ajax call
	 *		onQueueLimit : what to do if this Ajax call is blocked for exceeding the queue limit
	 *		onAjaxFilter : what to do on E_AJAX_FILTER (multiple calls of the exact same type)
	 *	extra_ajax_runner_options object (optional) : extra options to pass to ajax_runner
	 *		timeout : new timeout for this call (in ms)
	 *		queue_at_front : set to true to move to the front of the queue (moves to front of cmty_ajax queue, too)
	 *	queue_limit int (optional) : if the queue has length greater than this and there is
	 *			a currently active call, then we don't add this call to the queue and
	 *			we execute the onQueueLimit handler if it exists.
	 * 	source string (optional, default 'master')
	 **/
	cmty_ajax: {
		queue: [],

		has_active_call: false,

		time_profiling: true,

		ajax_active: true,

		fail_level: 0,

		/**
		 * Add an ajax call to the Community queue (or run one if one is not already running)
		 *
		 * @param object -- an Ajax call description object
		 **/
		add: function (obj) {
			var settings = _.extend(
				{
					never_cancel: false,
					source: "master",
					call_cancel_on_timeout: false,
				},
				obj
			);

			if (!this.ajax_active) {
				this.checkWarnCmtyAsleep();
				return;
			}

			if (!this.has_active_call) {
				this.run(settings);
			} else {
				if (settings.hasOwnProperty("queue_limit")) {
					if (this.queue.length > settings.queue_limit) {
						this.queueLimit(settings);
					}
				}
				if (
					obj.hasOwnProperty("extra_ajax_runner_options") &&
					obj.extra_ajax_runner_options.hasOwnProperty("queue_at_front") &&
					obj.extra_ajax_runner_options.queue_at_front
				) {
					this.queue.unshift(settings);
				} else {
					this.queue.push(settings);
				}
			}
		},

		/**
		 * Wipe out calls from the queue of a certain type.
		 *
		 * @param string type of call to spike.
		 **/
		clearCallsOfType: function (str) {
			var new_queue = [];

			_.each(this.queue, function (call) {
				if (call.a !== str) {
					new_queue.push(call);
				}
			});

			this.queue = new_queue;
		},

		/**
		 * When a call has been prevented due to queue limitations, we check if
		 * the call has an onQueueLimit handler.
		 *
		 * @param object : ajax call.
		 **/
		queueLimit: function (obj) {
			if (this.hasHandler(obj, "onQueueLimit")) {
				obj.extra_handlers.onQueueLimit();
			}
		},

		/**
		 * When there is a serious Ajax error, such as a database error or an internet outage,
		 *  then we throw a flyout, tell them we will try again shortly, and then put the post back in a queue.
		 * If we fail 5 times in a row, then we die.  I think we just live with double-posting.
		 **/
		onAjaxUnknown: function (obj) {
			var self = this,
				Lang = AoPS.Community.Lang,
				seconds_delay;

			seconds_delay =
				AoPS.Community.Constants.base_delay_internet_issue *
				Math.pow(2, this.fail_level);
			if (this.fail_level < 4) {
				this.queue.unshift(this.active_call);
				AoPS.Ui.Flyout.display(
					AoPS.Community.Utils.formatString(Lang["ajax-error-delay"], [
						seconds_delay,
					]),
					{
						class: "flyout-atop-modal",
					}
				);
				setTimeout(function () {
					self.runNext();
				}, 1000 * seconds_delay);
				console.log(
					"E_AJAX_UNKNOWN: Try again in " + seconds_delay + " seconds."
				);
				this.fail_level++;
			} else {
				this.ajax_active = false;
				AoPS.Community.Views.showErrorAtopAModal(
					Lang["ajax-error-E_AJAX_UNKNOWN"]
				);
			}
		},

		/**
		 * Prepare an Ajax call to be sent to ajax_runner.
		 *
		 * @param object -- an Ajax call description object
		 **/
		prepare: function (obj) {
			var handler,
				self = this;
			handler = function (ok, msg) {
				if (!ok) {
					if (msg.error_code === "E_INVALID_SESSION_WRONG") {
						//AoPS.Ui.Modal.showAlertQuick(AoPS.Community.Lang['err-no-such-session']);
						//AoPS.Ui.Modal.applyKillPhrase('ajax-error-kill');
						//self.fail_level = 0;
						//self.ajax_active = false;
						return;
					}
				}
				obj.main_handler(ok, msg);
				if (self.time_profiling) {
					if (
						AoPS.session.admin &&
						msg.hasOwnProperty("response") &&
						msg.response.hasOwnProperty("time_in_script")
					) {
						// console.log(obj.a + ' in ' + msg.response.time_in_script);
					}
				}

				if (ok) {
					if (self.hasHandler(obj, "onFinish")) {
						obj.extra_handlers.onFinish(msg.response);
					}

					if (typeof msg.response.cmty_status === "string") {
						if (
							typeof AoPS.Community === "object" &&
							typeof AoPS.Community.MasterModel === "object"
						) {
							AoPS.Community.MasterModel.set(
								"cmty_status",
								msg.response.cmty_status
							);
						}
					}
				} else {
					if (
						msg.error_code === "E_AJAX_TIMEOUT" &&
						obj.call_cancel_on_timeout
					) {
						msg.error_code = "E_AJAX_CANCEL";
					}
					if (
						msg.error_code === "E_AJAX_UNKNOWN" ||
						msg.error_code === "E_AJAX_BADRETURN"
					) {
						self.onAjaxUnknown();
						if (!self.ajax_active) {
							// Clear out loader modals so that users can copy their work.
							AoPS.Ui.Modal.applyKillPhrase("ajax-error-kill");
						}
						return;
					}
					// For now, we will eat all filtered Ajax calls;
					if (msg.error_code === "E_AJAX_FILTERED") {
						console.log("call filtered");
						if (self.hasHandler(obj, "onAjaxFilter")) {
							obj.extra_handlers.onAjaxFilter();
						}
					} else {
						if (
							self.hasHandler(obj, "onError") &&
							msg.error_code !== "E_COMMUNITY_DEACTIVATED"
						) {
							obj.extra_handlers.onError(msg);
						}
						if (msg.error_code === "E_COMMUNITY_DEACTIVATED") {
							if (self.hasHandler(obj, "onDeactivated")) {
								obj.extra_handlers.onDeactivated();
							}
						}
					}
				}

				self.fail_level = 0;
				self.runNext();
			};
			return {
				a: obj.a,
				params: obj.params,
				handler: handler,
			};
		},

		/**
		 * Run the submitted ajax call.
		 *
		 * @param object : an ajax_call object.
		 **/
		run: function (call) {
			var ajax_runner_input, options;
			if (!this.ajax_active) {
			}
			ajax_runner_input = this.prepare(call);
			options = call.hasOwnProperty("extra_ajax_runner_options")
				? call.extra_ajax_runner_options
				: {};
			if (this.ajax_active) {
				this.active_call = call;
				this.has_active_call = true;
				AoPS.Community.Utils.ajax_runner.run(
					ajax_runner_input.a,
					ajax_runner_input.params,
					ajax_runner_input.handler,
					options
				);
				this.current_ajax_runner_id =
					AoPS.Community.Utils.ajax_runner.getRunningQueueId();
			} else {
				this.checkWarnCmtyAsleep();
			}
		},

		checkWarnCmtyAsleep: function () {
			if (AoPS.Community.Utils.is_cmty_asleep) {
				AoPS.Ui.Flyout.display(
					AoPS.Community.Lang["community-asleep-reminder"],
					{
						class: "flyout-atop-modal",
					}
				);
			}
		},
		/**
		 * Run the next ajax_call in the queue if the queue is not empty.
		 **/
		runNext: function () {
			var self = this;
			var next;
			if (AoPS.Community.is_active && this.ajax_active) {
				if (this.queue.length > 0) {
					next = this.queue.shift();
					setTimeout(
						_.bind(function () {
							this.run(next);
						}, this),
						400
					);
				} else {
					this.current_ajax_runner_id = 0;
					this.active_call = null;
					this.has_active_call = false;
				}
			} else {
				// Shut down all the Ajax calls
				var queue = this.queue;
				// Reset this.queue before calls below to avoid infinite call loop.
				this.queue = [];
				_.each(queue, function (ajax_call) {
					var prepared_call = self.prepare(ajax_call);
					prepared_call.handler(false, {
						error_code: "E_COMMUNITY_DEACTIVATED",
					});
				});
			}
		},

		/**
		 * Checks if a given call object has the submitted handler among its extra handlers.
		 *
		 * @param obj : an ajax_call object.
		 * @param string : hander to search for.
		 **/
		hasHandler: function (call, handler) {
			return (
				call.hasOwnProperty("extra_handlers") &&
				typeof call.extra_handlers[handler] === "function"
			);
		},

		/**
		 * Cancel all of the ajax calls in the queue, based on the cancel_type
		 *	submitted and the never_cancel setting of each call.
		 *
		 * @param obj:
		 *		cancel_type string : 'all', 'feed', 'master'
		 **/
		cancelAll: function (obj) {
			var self = this;
			var retained_calls = [];
			_.each(this.queue, function (call) {
				if (self.checkCancel(obj, call)) {
					if (self.hasHandler(call, "onError")) {
						call.extra_handlers.onError({
							error_code: "E_AJAX_CANCEL",
						});
					}
				} else {
					retained_calls.push(call);
				}
			});

			if (this.has_active_call && this.checkCancel(obj, this.active_call)) {
				AoPS.Community.Utils.ajax_runner.cancelQueueId(
					this.current_ajax_runner_id
				);
			}
			this.queue = retained_calls;
		},

		/**
		 * Check if this call for cancellation should cancel this call.
		 *
		 * @param obj input to cancelAll
		 * @param obj ajax call object
		 **/
		checkCancel: function (cancel_obj, call) {
			// Turn this into a function; need to check a submitted cancel_type, etc
			if (call.never_cancel) {
				return false;
			}

			return (
				cancel_obj.cancel_type === "all" ||
				(cancel_obj.cancel_type === "feed" && call.source === "feed") ||
				(cancel_obj.cancel_type === "master" && call.source === "master")
			);
		},
	},

	/**
	 * The autotagger tags topics as posters are writing them.  It's waycool.
	 **/
	autotagger: (function () {
		var autotagger = {};

		/** Main autotagger dictionary built in CmtyTags::generateTermTagMap **/
		autotagger.dictionary = AoPS.Community.hasOwnProperty("term_tag_map")
			? AoPS.Community.term_tag_map
			: {};

		/** Minimum length of a string to spellcheck **/
		autotagger.min_spellcheck_len = 6;

		/**
		 * Check if the input string is a misspelled version of something that
		 *  we can map to a tag.
		 *
		 * @param string
		 * @return array tags that term maps to
		 **/
		autotagger.spellcheck = function (word) {
			var i,
				j,
				start,
				end,
				letter,
				new_word,
				transpose_start,
				alp_letter,
				alphabet = "abcdefghijklmnopqrstuvwxyz";

			for (i = 0; i < word.length; i++) {
				start = word.slice(0, i);
				end = word.slice(i + 1, word.length);
				letter = word.substr(i, 1);

				// check if inserted extra char
				new_word = start + end;
				if (autotagger.dictionary.hasOwnProperty(new_word)) {
					return autotagger.dictionary[new_word];
				}

				for (j = 0; j < 26; j++) {
					alp_letter = alphabet.substr(j, 1);

					// replace one letter
					if (alp_letter !== letter) {
						new_word = start + alp_letter + end;
						if (autotagger.dictionary.hasOwnProperty(new_word)) {
							return autotagger.dictionary[new_word];
						}
					}

					// check if deleted char
					new_word = start + alp_letter + letter + end;
					if (autotagger.dictionary.hasOwnProperty(new_word)) {
						return autotagger.dictionary[new_word];
					}
				}

				//transpositions
				if (i > 0) {
					transpose_start = word.slice(0, i - 1);
					new_word = transpose_start + letter + word.substr(i - 1, 1) + end;
					if (autotagger.dictionary.hasOwnProperty(new_word)) {
						return autotagger.dictionary[new_word];
					}
				}
			}

			// deleted end
			for (j = 0; j < 26; j++) {
				new_word = word + alphabet.substr(j, 1);
				if (autotagger.dictionary.hasOwnProperty(new_word)) {
					return autotagger.dictionary[new_word];
				}
			}

			return [];
		};

		/**
		 * Check if the submitted string is something we can map to a tag.
		 **/
		autotagger.tag = function (str) {
			if (autotagger.dictionary.hasOwnProperty(str)) {
				return autotagger.dictionary[str];
			} else if (str.length >= autotagger.min_spellcheck_len) {
				return autotagger.spellcheck(str);
			} else {
				return [];
			}
		};
		return autotagger;
	})(),

	buildUsernameAutocomplete: function ($input, settings) {
		var $no_results,
			position,
			onMatch = function () {},
			onNoMatch = function () {};
		settings = _.extend(
			{
				has_search_icon: false,
			},
			settings
		);

		position = settings.has_search_icon ? "left-21 top+5" : "left top+5";

		var autocomplete_settings = _.extend(
			{
				match_type: "from_start_then_any",
				ui_class: "cmty-username-autocomplete",
				delay: 250,
				is_case_sensitive: false,
				onOpen: function () {
					// Here is where to set a width of the drop down if we choose to
					//$input.autocomplete("widget").width(AoPS.Community.Constants.category_autocomplete_width);
				},
				source: function (request, response) {
					var cmty_ajax = AoPS.Community.Utils.cmty_ajax;
					cmty_ajax.clearCallsOfType(settings.ajax_call);
					cmty_ajax.add({
						a: settings.ajax_call,
						params: _.extend(
							{
								username_stub: request.term,
							},
							settings.hasOwnProperty("additional_ajax_settings")
								? settings.additional_ajax_settings
								: {}
						),
						main_handler: function (ok, msg) {
							var data,
								current_text = $input.val().substr(0, $input[0].selectionStart);

							if (request.term !== current_text) {
								response([]);
							}

							if (ok) {
								data = _.map(msg.response.usernames, function (item) {
									return _.defaults(item, {
										label: item.value,
									});
								});

								if (data.length === 0) {
									onNoMatch();
								} else {
									onMatch();
								}

								response(data);
							} else {
								response([]);
							}
						},
					});
				},
				_renderItem: function (ul, item) {
					var $list_item = $("<li></li>"),
						$link = $("<a>" + item.label + "</a>");

					$list_item.append($link);

					if (item.is_admin === "1") {
						$link.addClass("cmty-user-admin");
					}
					return $list_item.appendTo(ul);
				},
				num_matches: 10,
				position: {
					my: position,
				},
			},
			settings.autocomplete_settings
		);
		$input.wrap($('<div class="cmty-username-autocomplete-wrapper"></div>'));
		if (settings.has_search_icon) {
			$input.before('<span class="aops-font">M</span>');
			$input.parent().addClass("cmty-search-with-icon");
		}
		$input.aopsAutocomplete(autocomplete_settings);
		if (
			settings.hasOwnProperty("show_no_results_msg") &&
			settings.show_no_results_msg
		) {
			$no_results = settings.hasOwnProperty("$no_results")
				? settings.$no_results
				: $(
						'<div class="cmty-no-results-found">' +
							AoPS.Community.Lang["search-no-match"] +
							"</div>"
					);
			$input.before($no_results);
			$input.on("blur remove", function () {
				$no_results.hide();
			});
			onMatch = function () {
				$no_results.hide();
			};
			onNoMatch = function () {
				$no_results.show();
				$no_results.position({
					my: "left-1 top+1",
					at: "left bottom",
					of: $input,
				});
			};
		}
	},

	// CSS currently in /assets/css/community.css
	/**
	 * Build an autocomplete of categories.
	 *
	 * @param jQuery object -- input field to make into an autocomplete.
	 *		obj
	 *			ajax_call string required
	 *			include_wrapper boolean default true (if false, then has_search_icon is forced false)
	 *			has_search_icon boolean default false
	 *			autocomplete_settings obj required may be empty
	 *			additional_ajax_settings obj optional
	 *
	 * NOTE: Let this function wrap the input.  Don't put the wrapper on
	 *  beforehand.  And if you're going to rebuild the autocomplete,
	 *  you need to nuke the wrapper, and everything in it.
	 *
	 * Perhaps build a "rebuild" functionality?
	 **/
	buildCategoryAutocomplete: function ($input, settings) {
		var $no_results,
			position,
			onMatch = function () {},
			onNoMatch = function () {};
		settings = _.extend(
			{
				include_wrapper: true,
				has_search_icon: false,
			},
			settings
		);

		position = settings.has_search_icon ? "left-21 top+5" : "left top+5";
		var autocomplete_settings = _.extend(
			{
				match_type: "from_start_then_any",
				delay: 250,
				onOpen: function () {
					$input
						.autocomplete("widget")
						.width(AoPS.Community.Constants.category_autocomplete_width);
				},
				is_case_sensitive: false,
				source: function (request, response) {
					var cmty_ajax = AoPS.Community.Utils.cmty_ajax;
					cmty_ajax.clearCallsOfType(settings.ajax_call);
					cmty_ajax.add({
						a: settings.ajax_call,
						params: _.extend(
							{
								category_stub: request.term,
							},
							settings.hasOwnProperty("additional_ajax_settings")
								? settings.additional_ajax_settings
								: {}
						),
						main_handler: function (ok, msg) {
							var data,
								current_text = $input.val().substr(0, $input[0].selectionStart);

							if (request.term !== current_text) {
								response([]);
							}

							if (ok) {
								data = _.map(msg.response.categories, function (item) {
									return _.defaults(item, {
										label: item.value,
									});
								});

								if (data.length === 0) {
									onNoMatch();
								} else {
									onMatch();
								}

								response(data);
							} else {
								response([]);
							}
						},
					});
				},
				/**
				 * When we render an item in this list, we need to color it based on properties of that item
				 */
				_renderItem: function (ul, item) {
					var $li = $("<li>")
							.addClass("cmty-category-autocomplete-item-" + item.category_type)
							.css({
								color: item.main_color,
							}),
						$item = $('<a class="cmty-category-autocomplete">')
							.text(item.label)
							.css({
								color: item.main_color,
								//		'background-color' : item.main_color
							})
							.data({
								"main-color": item.main_color,
								"secondary-color": item.secondary_color,
							});
					return $li.append($item).appendTo(ul);
				},
				/**
				 * When an item is focused, we need to color it appropriately, and
				 *  un-color the old focus element.
				 */
				onFocus: _.bind(function (event, ui) {
					if (
						this.hasOwnProperty("focus_element") &&
						!_.isNull(this.focus_element)
					) {
						this.focus_element.css({
							color: this.focus_element.data("main-color"),
							"background-color": "",
						});
					}
					this.focus_element = $(event.originalEvent.target).find(
						"a.ui-state-focus"
					);

					this.focus_element.css({
						color: this.focus_element.data("secondary-color"),
						"background-color": this.focus_element.data("main-color"),
					});
				}, this),
				num_matches: 10,
				position: {
					my: position,
				},
				ui_class: "category-autocomplete",
			},
			settings.autocomplete_settings
		);
		if (settings.include_wrapper) {
			$input.wrap($('<div class="cmty-category-autocomplete-wrapper"></div>'));
			if (settings.has_search_icon) {
				$input.before('<span class="aops-font">M</span>');
				$input.parent().addClass("cmty-search-with-icon");
			}
		}
		$input.aopsAutocomplete(autocomplete_settings);
		if (
			settings.hasOwnProperty("show_no_results_msg") &&
			settings.show_no_results_msg
		) {
			$no_results = settings.hasOwnProperty("$no_results")
				? settings.$no_results
				: $(
						'<div class="cmty-no-results-found">' +
							AoPS.Community.Lang["search-no-match"] +
							"</div>"
					);
			$input.before($no_results);
			$input.on("blur remove", function () {
				$no_results.hide();
			});
			onMatch = function () {
				$no_results.hide();
			};
			onNoMatch = function () {
				$no_results.show();
				$no_results.position({
					my: settings.has_search_icon ? "left-22 top+4" : "left-1 top+1",
					at: "left bottom",
					of: $input,
				});
			};
		}
	},

	/**
	 * Function used by aopsAutocomplete to go to the database and
	 *  find usernames that match the string input in the request.
	 *
	 * @param object : request object as per jQueryUI Autocomplete specs
	 * @param object : response object as per jQueryUI Autocomplete specs
	 */
	fetchUsernameMatches: function (obj) {
		this.cmty_ajax.clearCallsOfType("fetch_username_matches");
		this.cmty_ajax.add({
			a: "fetch_username_matches",
			params: {
				username_stub: obj.request.term,
			},
			main_handler: _.bind(function (ok, msg) {
				var data;
				if (obj.hasOwnProperty("checkSquelch") && obj.checkSquelch()) {
					obj.response([]);
					return;
				}
				if (ok) {
					data = _.map(msg.response.usernames, function (item) {
						return _.defaults(item, {
							label: item.value,
						});
					});

					obj.response(data);
				} else {
					obj.response([]);
				}
			}, this),
		});
	},

	/**
	 * Check if a username is a real username.
	 *  The Ajax call returns an object:
	 *		is_valid boolean
	 *		is_admin 0|1
	 *		user_id 0|valid user id
	 *
	 * @param obj
	 *		username string
	 *		onFinish function
	 **/
	checkValidUsername: function (obj) {
		this.cmty_ajax.add({
			a: "check_valid_username",
			params: {
				username: obj.username,
			},
			main_handler: function (ok, msg) {}, // all the action gets passed in
			extra_handlers: obj,
		});
	},

	capitalizeFirstLetter: function (str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	},

	/**
	 * Turn the category type into a word that the users will recognize (for communicating
	 *  information in error messages).
	 *
	 * @param string
	 **/
	displayCategoryType: function (type) {
		return AoPS.Community.Lang[AoPS.Community.Utils.simplifyCategoryType(type)];
	},

	format_str_regexp: new RegExp("{-?[0-9]+}", "g"),

	formatString: function (str, args) {
		return str.replace(AoPS.Community.Utils.format_str_regexp, function (item) {
			var index = parseInt(item.substring(1, item.length - 1));
			var replace;
			if (index >= 0) {
				replace = _.escape(args[index]);
			} else if (index === -1) {
				replace = "{";
			} else if (index === -2) {
				replace = "}";
			} else {
				replace = "";
			}
			return replace;
		});
	},

	lastRegexp: /(^Last\s)/,

	/**
	 * Note: the time_hack_nudge in the adjustment to the time is there because sometimes the offset puts us a
	 *  few milliseconds in the future.  Or because time.fromNow() calls "now" a time that is "a few seconds
	 *  from now".
	 **/
	makePrettyTime: function (int_time) {
		var time,
			time_diff_from_now,
			seconds_ago = parseInt(moment().format("X")) - int_time;

		if (seconds_ago < AoPS.Community.Constants.time_limits.watched_times_long) {
			// Last 6 hours.
			time = moment(String(int_time), "X").add(
				"milliseconds",
				-AoPS.Community.Constants.moment_offset -
					AoPS.Community.Constants.time_hack_nudge
			);
			time_diff_from_now = time.diff(moment());

			if (time_diff_from_now > 0 && time_diff_from_now < 120000) {
				time = moment().subtract(2, "seconds");
			}

			return time.fromNow();
		} else {
			time = moment(String(int_time), "X").add(
				"milliseconds",
				-AoPS.Community.Constants.moment_offset
			);
			if (
				seconds_ago < AoPS.Community.Constants.time_limit_for_calendar_style
			) {
				// Last 3 days.
				return time.calendar().replace(AoPS.Community.Utils.lastRegexp, "");
			} else {
				return time.format("MMM D, YYYY, h:mm A");
			}
		}
	},

	/**
	 * Note: the time_hack_nudge in the adjustment to the time is there because sometimes the offset puts us a
	 *  few milliseconds in the future.  Or because time.fromNow() calls "now" a time that is "a few seconds
	 *  from now".
	 **/
	makePrettyTimeOldDateOnly: function (int_time) {
		var time,
			time_diff_from_now,
			seconds_ago = parseInt(moment().format("X")) - int_time;

		if (seconds_ago < AoPS.Community.Constants.time_limits.watched_times_long) {
			// Last 6 hours.
			time = moment(String(int_time), "X").add(
				"milliseconds",
				-AoPS.Community.Constants.moment_offset -
					AoPS.Community.Constants.time_hack_nudge
			);
			time_diff_from_now = time.diff(moment());

			if (time_diff_from_now > 0 && time_diff_from_now < 120000) {
				time = moment().subtract(2, "seconds");
			}

			return time.fromNow();
		} else {
			time = moment(String(int_time), "X").add(
				"milliseconds",
				-AoPS.Community.Constants.moment_offset
			);

			if (
				seconds_ago < AoPS.Community.Constants.time_limit_for_calendar_style
			) {
				// Last 2 days.
				return time.calendar().replace(AoPS.Community.Utils.lastRegexp, "");
			} else {
				return time.format("MMM D, YYYY");
			}
		}
	},

	makePrettyTimeStatic: function (int_time) {
		var time = moment(String(int_time), "X");

		return time.format("MMM D, YYYY, h:mm A");
	},

	makePrettyTimeStaticDateOnly: function (int_time) {
		var time = moment(String(int_time), "X");

		return time.format("MMM D, YYYY");
	},

	getLastVisitedText: function (item) {
		if (item.item_subtitle === "online") {
			return AoPS.Community.Lang["user-item-online"];
		} else if (item.last_active === 0) {
			return "";
		} else {
			return this.makePrettyTimeStatic(item.last_active);
		}
	},

	/**
	 * The Community and Blog routers share a lot of pieces.
	 **/
	routerBase: Backbone.Router.extend({
		errors: {
			my_aops_not_logged_in: {
				error_type: "custom",
				error_msg:
					"COPY/STYLING NEEDED -- There will be awesome stuff on this My AoPS page when you are logged in!!<br><i>This message brought to you by the errors object near the top of the Community Router object.",
			},
		},

		// The order is important.  Maybe someday I will fix that.
		url_parameters: [
			{
				letter: "c",
				property: "category_id",
			},
			{
				letter: "x",
				property: "priv_id",
			},
			{
				letter: "u",
				property: "user_id",
			},
			{
				letter: "q",
				property: "search_id",
			},
			{
				letter: "t",
				property: "tag_id",
			},
			{
				letter: "f",
				property: "tag_forum_id",
			},
			{
				letter: "h",
				property: "topic_id",
			},
			{
				letter: "p",
				property: "post_id",
			},
			{
				// denotes whether or not we go to start or end of topic
				letter: "s",
				property: "state",
			},
		],

		/**
		 * Preloaded Data has form
		 *
		 * category_id
		 * post_id
		 * post_id_data {delete_status, post_number, topic_id}
		 * rewrite_url
		 * topic_data
		 * topic_id
		 */
		parsePreloadedData: function () {
			var preload_data = AoPS.bootstrap_data.preload_cmty_data,
				category_id = fetchPreloadedSetting("category_id"),
				topic_id = fetchPreloadedSetting("topic_id"),
				post_id = fetchPreloadedSetting("post_id"),
				user_id = fetchPreloadedSetting("user_id"),
				topic;

			function fetchPreloadedSetting(variable) {
				if (preload_data.hasOwnProperty(variable)) {
					return preload_data[variable];
				} else {
					return 0;
				}
			}

			/**
			 * If there's an error in preload, then don't do anything else
			 **/
			if (preload_data.hasOwnProperty("error")) {
				this.processError(preload_data.error);
				return true;
			}

			/**
			 * If we have preloaded a topic, then we build it.
			 **/
			if (preload_data.hasOwnProperty("topic_data")) {
				topic = this.models.master.processPotentialNewTopic(
					preload_data.topic_data
				);
				this.preloaded_topic_id = topic_id;
				topic.set(
					"last_posts_update_time",
					preload_data.topic_data.last_posts_update_time
				);
			}

			/**
			 * If we have a preloaded user, add it to the master collection of users.
			 **/
			if (preload_data.hasOwnProperty("user")) {
				this.models.master
					.get("users")
					.add(new AoPS.Community.Models.User(preload_data.user));
			}

			/**
			 * If the URL needs to be rebuilt based on what was originally sent to the server,
			 *  then we flag that on the back end, and pull off the rewrite here.
			 *  Note that we will ignore the submitted tag_id, tag_forum_id, and state.
			 *  TODO : Can we retain any of those ignored bits.  Probably care most about state.
			 **/
			if (
				preload_data.hasOwnProperty("rewrite_url") &&
				preload_data.rewrite_url
			) {
				this.rebuildPageFromStart({
					category_id: category_id,
					topic_id: topic_id,
					post_id: post_id,
					priv_id: 0,
					user_id: user_id,
					search_id: 0,
					tag_id: 0,
					tag_forum_id: 0,
					state: 0,
				});
				return true;
			}

			return false;
		},

		throwError: function (error) {
			this.myPage.throwError({
				error_type: "custom",
				error_msg: error,
			});
		},

		/**
		 * When the user doesn't have permissions to access a page, we
		 *  throw an error with text based on whether or not the user is logged in.
		 **/
		throwNoPermissions: function () {
			if (AoPS.session.logged_in) {
				this.throwError(AoPS.Community.Lang["router-err-no-perms-logged-in"]);
			} else {
				this.throwError(AoPS.Community.Lang["router-err-no-perms-logged-out"]);
			}
		},

		/**
		 * Process an error code that was submitted via preload or some Ajax fetch.
		 **/
		processError: function (error) {
			switch (error) {
				case "E_NO_SUCH_POST":
					this.throwError(AoPS.Community.Lang["router-err-no-post"]);
					break;

				case "E_NO_SUCH_TOPIC":
					this.throwError(AoPS.Community.Lang["router-err-no-topic"]);
					break;

				case "E_NOT_PARTICIPANT":
					this.throwError(AoPS.Community.Lang["router-err-not-participant"]);
					break;

				case "E_NO_PERMISSION":
					if (AoPS.session.logged_in) {
						this.throwError(
							AoPS.Community.Lang["router-err-no-perms-logged-in"]
						);
					} else {
						this.throwError(
							AoPS.Community.Lang["router-err-no-perms-logged-out"]
						);
					}
					break;

				case "E_TOPIC_DELETED":
					this.throwError(AoPS.Community.Lang["router-err-topic-deleted"]);
					break;

				case "E_NO_SUCH_CATEGORIES":
					this.throwError(AoPS.Community.Lang["router-err-no-such-category"]);
					break;

				case "E_NO_SUCH_TAG":
					this.throwError(AoPS.Community.Lang["router-err-no-such-tag"]);
					break;

				case "E_TOO_FAST":
					this.throwError(AoPS.Community.Lang["err-too-fast"]);
					break;
			}
		},

		/** Start URL Rewriting functions **/

		/**
		 * Rebuild the Url based on the current coords settings.
		 *  Does not reload the page.  Used to rewrite URLs when the URL
		 *  has faulty data, like the wrong forum for a topic.
		 *
		 * @param coords: settings used to build the page.
		 **/
		rebuildUrl: function (coords) {
			var url = "";
			function addString(letter, property) {
				// eslint-disable-next-line eqeqeq
				return coords[property] != 0 ? letter + coords[property] : "";
			}

			_.each(this.url_parameters, function (item) {
				url += addString(item.letter, item.property);
			});

			if (url.length === 0) {
				Backbone.history.navigate(url, {trigger: true, replace: false});
				return false;
			} else {
				Backbone.history.navigate(url, {trigger: false, replace: true});
				return true;
			}
		},

		/**
		 * Rebuild the page from scratch based on the current coordinates,
		 *  rewriting the URL before we start.
		 *
		 * @param coords: settings used to build the page.
		 **/
		rebuildPageFromStart: function (coords) {
			if (this.rebuildUrl(coords)) {
				this.myPage.showBreadcrumbs();
				this.startConstructingPage(coords);
			}
		},
	}),

	/**
	 * Maps all the "collection" types to "collection"
	 */
	simplifyCategoryType: function (type) {
		switch (type) {
			case "forum":
			case "forum_class":
				return "forum";

			case "blog":
				return "blog";

			default:
				return "collection";
		}
	},

	renderNumberWithCommas: function (num) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},

	mouseOverTip: function (head) {
		var shape = head.next();
		var txt = shape.next();
		shape.toggle();
		txt.toggle();
		head.toggleClass("cmty-tip-open");
		head.addClass("first-time");
		var top = head.offset().top + head.height();
		shape.offset({
			top: top,
			left: head.offset().left + head.outerWidth() / 2 - 6,
		});
		var left;
		var head_left = head.offset().left - head.parent().offset().left;
		var head_right = head.parent().outerWidth() - head_left - head.outerWidth();
		var no_fit_right = txt.outerWidth() > head.outerWidth() + 2 * head_right;
		var no_fit_left = txt.outerWidth() > head.outerWidth() + 2 * head_left;
		if (no_fit_right === no_fit_left) {
			left = head.offset().left + head.outerWidth() / 2 - txt.outerWidth() / 2;
		} else if (no_fit_right) {
			left =
				head.offset().left + head.outerWidth() + head_right - txt.outerWidth();
		} else {
			left = head.offset().left - head_left;
		}
		txt.offset({top: top + 7.5, left: left});
	},

	mouseOutTip: function (head) {
		head.next().toggle();
		head.next().next().toggle();
		head.toggleClass("cmty-tip-open");
	},

	clickMidlineHide: function (head) {
		head.next().next().toggle();
		head.toggleClass("cmty-hide-open");
		return false;
	},

	clickHide: function (head) {
		head.next().toggle();
		head.toggleClass("cmty-hide-open");
		return false;
	},

	onClickBan: function (e) {
		AoPS.Community.MasterModel.banAsSpammer({
			user_id: e.currentTarget.getAttribute("user_id"),
		});
		$(e.currentTarget).hide();
	},

	onClickTroll: function (e) {
		AoPS.Ui.Modal.showConfirm(
			AoPS.Community.Lang["cat-admin-troll-confirm"],
			function (ok) {
				if (ok) {
					AoPS.Community.MasterModel.banAsSpammer({
						user_id: e.currentTarget.getAttribute("user_id"),
						is_troll: true,
					});
					// then we need to remove all of the user's posts
					$(e.currentTarget).hide();
					AoPS.Ui.Modal.closeTopModal();
				} else {
					AoPS.Ui.Modal.closeTopModal();
				}
			},
			{
				close_on_button_click: false,
			}
		);
	},

	onClickTempBan: function (options) {
		var data = _.omit(options, "success");
		var template = AoPS.View.compileTemplate("#cmty-user-temp-ban-tpl");
		var $confirm = $("<div />").append(
			$.parseHTML($.trim(template && template(data)))
		);

		if (data.can_temp_ban && data.can_access) {
			$confirm
				.find(".yeet-box")
				.after(
					$("<div />")
						.css("margin-bottom", "15px")
						.append($("<h3 />").text("Reason:"))
						.append(AoPS.Community.Utils.getModerationInputsForType("mod"))
				);
		}

		var modal = AoPS.Ui.Modal[data.can_temp_ban ? "showConfirm" : "showAlert"](
			$confirm,
			function (ok) {
				var action = $confirm.find("input[name='action']:checked").val() || "";
				var reason = $confirm.find("input[name='reason']:checked").val() || "";

				if (ok && data.can_temp_ban && action) {
					AoPS.Community.MasterModel.handleTempBan({
						user_id: options.user_id,
						action: action,
						reason: reason,
						success: options.success,
					});
				}
				AoPS.Ui.Modal.removeModal(modal);
			},
			{
				close_on_button_click: false,
			}
		);
	},

	getModerationReasonsForType: function (type) {
		return (
			(
				_.findWhere((AoPS.bd || {}).all_moderation_reasons || [], {
					type: type,
				}) || {}
			).reasons || []
		);
	},

	getModerationInputsForType: function (type) {
		return _.reduce(
			AoPS.Community.Utils.getModerationReasonsForType(type),
			function ($form, reason) {
				return $form.append(
					$("<label />")
						.css({
							display: "block",
							cursor: "pointer",
						})
						.text(reason.reason)
						.prepend(
							$("<input />")
								.css("margin-right", "4px")
								.attr({type: "radio", name: "reason"})
								.prop("checked", reason.default)
								.val(reason.value)
						)
				);
			},
			$("<div />")
		);
	},
};

AoPS.Community.Utils.ajax_runner.addGlobalHandler(function (ok, msg) {
	if (msg.response.hasOwnProperty("user_session_data")) {
		if (
			msg.response.user_session_data.logged_in !== AoPS.session.logged_in ||
			msg.response.user_session_data.user_id !== AoPS.session.user_id
		) {
			// Uh-oh user logged out!!!
			AoPS.session.username = msg.response.user_session_data.username;
			AoPS.session.user_id = msg.response.user_session_data.user_id;
			AoPS.session.logged_in = msg.response.user_session_data.logged_in;
			if (AoPS.session.logged_in) {
				Backbone.trigger("logged_in");
			} else {
				Backbone.trigger("logged_out");
			}
		}
	} else {
		console.log("No user session data found in ajax call");
	}
	if (ok) {
	} else {
		if (msg.error_code === "E_COMMUNITY_DEACTIVATED") {
			AoPS.Community.is_active = false;
			if (AoPS.Community.Views.inCmtyRouter()) {
				window.location.href = "/community";
			} else {
				Backbone.trigger("community_disabled");
			}
		}
		if (msg.error_code === "E_INVALID_SESSION_WRONG") {
			AoPS.Community.Utils.putCommunityToSleep({
				error_type: "E_INVALID_SESSION_WRONG",
			});
			AoPS.Ui.Modal.showAlertQuick(AoPS.Community.Lang["err-no-such-session"]);
			AoPS.Ui.Modal.applyKillPhrase("ajax-error-kill");
			//				AoPS.Community.Utils.ajax_active = false;

			return;
		}
	}
});
